export default __webpack_public_path__ + "static/media/SameCountry.d5ab655c.PNG";